import { render } from "./SettingsLayout.vue?vue&type=template&id=e0fdecd8&ts=true"
import script from "./SettingsLayout.vue?vue&type=script&lang=ts"
export * from "./SettingsLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__